import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from "@angular/core";
import { Chart, ChartType } from "chart.js";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import * as moment from "moment";
import { DoctorDashboardService } from "src/app/services/doctor-dashboard.service/doctor-dashboard.service";

@Component({
  selector: "app-chart-consultation",
  templateUrl: "./chart-consultation.component.html",
  styleUrls: ["./chart-consultation.component.css"],
})
export class ChartConsultationComponent implements OnInit, OnDestroy {

  @ViewChild('consultationsCanvas', { static: true })
  canvas!: ElementRef<HTMLCanvasElement>;

  private destroy$ = new Subject<void>();
  private chart?: Chart;

  startDate = new Date(new Date().getFullYear(), new Date().getMonth() - 1);
  finDate = new Date(new Date().getFullYear(), new Date().getMonth(), 0);

  consultationsMotifsStatistics: Array<{
    id: string;
    label: string;
    color: string;
    consultations: number;
  }> = [];

  constructor(private doctorDashboardService: DoctorDashboardService) {}

  ngOnInit(): void {
    this.staticRdv();
  }

  staticRdv(): void {
    this.doctorDashboardService
      .staticConsultations(this.startDate.getTime(), this.finDate.getTime())
      .pipe(takeUntil(this.destroy$))
      .subscribe(res => {
        this.consultationsMotifsStatistics = res;
        this.renderChart();
      });
  }

  private renderChart(): void {
    if (this.chart) {
      this.chart.destroy();
    }

    this.chart = new Chart(this.canvas.nativeElement, {
      type: "pie" as ChartType,
      data: {
        labels: this.consultationsMotifsStatistics.map(e => e.label),
        datasets: [{
          data: this.consultationsMotifsStatistics.map(e => e.consultations),
          backgroundColor: this.consultationsMotifsStatistics.map(e => e.color),
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false
      }
    });
  }

  ngOnDestroy(): void {
    if (this.chart) {
      this.chart.destroy();
    }
    this.destroy$.next();
    this.destroy$.complete();
  }
}
